import request from '@/utils/request'
import config from '@/config'
export default {
  // 获取水位详情信息
  get5MYuRunData (params) {
    return request.get(config.ApiYSQ + '/HydrologyCenter/Get5MYuRunData', { params })
  },
  // 获取河道水位信息
  getStatisticsRiverWater (params) {
    return request.get(config.ApiYSQ + '/HydrologyCenter/GetStatisticsRiverWater', { params })
  },
  // 获取最新时间的水位
  GetLatestWaterLevel (params) {
    return request.get(config.ApiYSQ + '/HydrologyCenter/GetLatestWaterLevel', { params })
  }
}
